module.exports = __webpack_public_path__ + "img/23.0818a715.png";